<form [formGroup]="otherBankForm">
  <div class="mt-3 mb-4" [ngClass]="{ 'bb-fieldset__heading': largeTitles }"
    i18n="@@contact-manager.other-form.contactData">
    Contact information
  </div>
  <fieldset class="bn-contact-manager-form__fieldset pb-3">
    <div class="row">
      <div class="bb-block col-12 mb-3">
        <label i18n="@@contact-manager.other-form.idType">Identification type</label>
        <bb-dropdown-single-select-ui [placeholder]="selectIdTypeTooltip" [options]="idTypes"
          displayAttributePath="desc" formControlName="idType" class="d-block bb-block bb-block--lg mb-0">
        </bb-dropdown-single-select-ui>
      </div>
      <div class="bb-block col-12 mb-1">
        <label i18n="@@contact-manager.other-form.idNumber">Identification</label>
        <input class="form-control" formControlName="idNumber" [mask]="idTypeMask" />
        <bb-input-validation-message-ui role="alert"
          [showErrors]="otherBankForm.controls.idNumber.invalid && (otherBankForm.controls.idNumber.dirty || otherBankForm.controls.idNumber.touched)">
          <ng-container *ngIf="otherBankForm.controls.idNumber.errors?.required">
            <span i18n="@@contact-manager.other-form.idRequired">
              Identification number is required
            </span>
          </ng-container>
          <ng-container *ngIf="otherBankForm.controls.idNumber.errors?.cip">
            <span i18n="@@contact-manager.other-form.cipError">
              Identification must be 11 numeric characters
            </span>
          </ng-container>
          <ng-container *ngIf="otherBankForm.controls.idNumber.errors?.pas">
            <span i18n="@@contact-manager.other-form.pasError">
              Passport must have at least 4 alphanumeric characters and no more than 15
            </span>
          </ng-container>
          <ng-container *ngIf="otherBankForm.controls.idNumber.errors?.rnc">
            <span i18n="@@contact-manager.other-form.rncError">
              RNC must be 9 numeric characters
            </span>
          </ng-container>
          <ng-container *ngIf="otherBankForm.controls.idNumber.errors?.invalidNumber">
            <span i18n="@@contact-manager.other-form.validation.invalid-id-number">
              You must validate the identification number to continue
            </span>
          </ng-container>
        </bb-input-validation-message-ui>
      </div>
      <div class="bb-block col-12 mb-3">
        <div *ngIf="loadingValidation">
          <bb-loading-indicator-ui></bb-loading-indicator-ui>
        </div>
        <div *ngIf="!loadingValidation">
          <label i18n="
             @@contact-manager.other-form.name">Beneficiary name</label>
          <bb-input-text-ui formControlName="name" [readonly]="otherBankForm?.controls?.idType?.value?.id !== 'PAS'">
          </bb-input-text-ui>
          <bb-input-validation-message-ui role="alert"
            [showErrors]="otherBankForm.controls.name.invalid && (otherBankForm.controls.name.dirty || otherBankForm.controls.name.touched)">
            <ng-container *ngIf="otherBankForm.controls.name.errors?.pattern">
              <span i18n="@@contact-manager.other-form.namePattern">
                Beneficiary name must only have letters
              </span>
            </ng-container>
          </bb-input-validation-message-ui>
        </div>
      </div>

      <div class="pl-3 mt-4 mb-4 mt-1" *ngIf="!bankTitle" i18n="@@contact-manager.other-form.bankData">
        Bank information
      </div>
      <div class="pl-3 mt-4 mb-4" [ngClass]="{ 'bb-fieldset__heading': largeTitles }" *ngIf="!!bankTitle">
        {{ bankTitle }}
      </div>

      <div class="bb-block col-12 mb-3">
        <label *ngIf="!customLabels?.accountNumber" i18n="@@contact-manager.other-form.accountNumber">Account
          number</label>
        <label *ngIf="customLabels?.accountNumber">{{customLabels.accountNumber}}</label>
        <input class="form-control" autocomplete="off" formControlName="accountNumber" bnAccountNumberMask />
        <bb-input-validation-message-ui role="alert"
          [showErrors]="otherBankForm.controls.accountNumber.invalid && (otherBankForm.controls.accountNumber.dirty || otherBankForm.controls.accountNumber.touched)">
          <ng-container *ngIf="otherBankForm.controls.accountNumber.errors?.required">
            <span i18n="@@contact-manager.other-form.accountNumberRequired">
              Account number is required
            </span>
          </ng-container>
          <ng-container *ngIf="otherBankForm.controls.accountNumber.errors?.maxlength">
            <span i18n="@@contact-manager.other-form.accountNumberMaxLength">
              Account number must not exceed 34 characters
            </span>
          </ng-container>
        </bb-input-validation-message-ui>
      </div>
      <div class="bb-block col-12 mb-3">
        <label i18n="@@contact-manager.other-form.bank">Bank</label>
        <ng-select
                   [selectOnTab]="true"
                   [placeholder]="'Selecciona el banco'"
                   class="bb-account-selector custom"
                   formControlName="bank"
                   [dropdownPosition]="'bottom'"
                   [clearable]="false"
                   id="searchFilterCustom"
        >
          <ng-option *ngFor="let bank of banks"
                     [value]="bank">
            {{ bank.desc }}
          </ng-option>
        </ng-select>
         <bb-input-validation-message-ui role="alert"
          [showErrors]="otherBankForm.controls.bank.invalid && (otherBankForm.controls.bank.dirty || otherBankForm.controls.bank.touched)">
          <ng-container *ngIf="otherBankForm.controls.bank.errors?.required">
            <span i18n="@@contact-manager.other-form.bankRequired">
              Bank is required
            </span>
          </ng-container>
        </bb-input-validation-message-ui>
      </div>
      <div class="bb-block col-12 mb-3">
        <div class="d-flex align-items-center">
          <label i18n="@@contact-manager.other-form.productType">Product type</label>
          <span bbTooltip="Para Tarjetas de Crédito y Préstamos, ir a la sección de Pagos" placement="right">
            <bb-icon-ui name="info" color="info" size="md"></bb-icon-ui>
          </span>
        </div>
        <bb-dropdown-single-select-ui [placeholder]="selectProductTypePlaceholder" [options]="productTypes"
          displayAttributePath="desc" formControlName="productType" class="d-block bb-block bb-block--lg mb-0">
        </bb-dropdown-single-select-ui>

        <bb-input-validation-message-ui role="alert"
          [showErrors]="otherBankForm.controls.productType.invalid && (otherBankForm.controls.productType.dirty || otherBankForm.controls.productType.touched)">
          <ng-container *ngIf="otherBankForm.controls.productType.errors?.required">
            <span i18n="@@contact-manager.other-form.productTypeRequired">
              Product type is required
            </span>
          </ng-container>
        </bb-input-validation-message-ui>
      </div>
      <div class="bb-block col-12 mb-3">
        <label i18n="@@contact-manager.other-form.currency">Currency</label>
        <bb-dropdown-single-select-ui [placeholder]="selectCurrencyPlaceholder" [options]="currencies"
          displayAttributePath="desc" formControlName="currency" class="d-block bb-block bb-block--lg mb-0">
        </bb-dropdown-single-select-ui>

        <bb-input-validation-message-ui role="alert"
          [showErrors]="otherBankForm.controls.currency.invalid && (otherBankForm.controls.currency.dirty || otherBankForm.controls.currency.touched)">
          <ng-container *ngIf="otherBankForm.controls.productType.errors?.required">
            <span i18n="@@contact-manager.other-form.currencyRequired">
              Currency is required
            </span>
          </ng-container>
        </bb-input-validation-message-ui>
      </div>

      <div class="pl-3 mt-4 mb-4 mt-1" *ngIf="optionalFields" i18n="@@contact-manager.other-form.optionalData">
        Optional data
      </div>
      <div class="bb-block col-12 mb-3" *ngIf="optionalFields">
        <label i18n="@@contact-manager.other-form.alias">
          Alias (optional)
        </label>
        <bn-semaphore-tooltip class="ml-1" [text]="infoTooltipText" type="info"></bn-semaphore-tooltip>
        <bb-input-text-ui formControlName="alias"></bb-input-text-ui>
      </div>
      <div class="bb-block col-12 mb-3" *ngIf="optionalFields">
        <label i18n="@@contact-manager.other-form.email">E-mail (optional)</label>
        <bb-input-text-ui formControlName="email"></bb-input-text-ui>
      </div>
    </div>
  </fieldset>
</form>


<div style="display: none;">
  <div i18n="@@contact-manager.other-form.successMessage">Beneficiary created successfully</div>
  <div i18n="@@contact-manager.other-form.errorMessage">Something went wrong</div>
  <div i18n="@@contact-manager.other-form.selectIDType">Select an ID type</div>
  <div i18n="@@contact-manager.other-form.selectBank">Select a bank</div>
  <div i18n="@@contact-manager.other-form.selectProductType">Select a product type</div>
  <div i18n="@@contact-manager.other-form.selectCurrency">Select a currency</div>
  <div i18n="@@contact-manager.other-form.idError">There was an error with the validation service</div>
</div>
